import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function OrderSuccessModal({ order, onClose, onExportPDF }) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{ backgroundColor: "rgba(17,24,39,0.5)" }}>
      <div className="bg-card border border-border rounded-lg shadow-xl w-full max-w-sm text-center">
        <div className="p-6">
          <div className="w-16 h-16 rounded-full bg-success/10 flex items-center justify-center mx-auto mb-4">
            <Icon name="CheckCircle" size={36} color="var(--color-success)" strokeWidth={2} />
          </div>
          <h3 className="font-heading font-bold text-lg text-foreground mb-1">Order Placed!</h3>
          <p className="font-caption text-sm text-muted-foreground mb-4">Your order has been submitted successfully.</p>
          <div className="bg-muted rounded-md p-3 mb-4 text-left space-y-1.5">
            <div className="flex justify-between">
              <span className="font-caption text-xs text-muted-foreground">Order ID</span>
              <span className="font-data text-xs font-semibold text-foreground">{order?.id}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-caption text-xs text-muted-foreground">Account</span>
              <span className="font-caption text-xs text-foreground truncate max-w-[160px]">{order?.account}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-caption text-xs text-muted-foreground">Items</span>
              <span className="font-data text-xs text-foreground">{order?.itemCount}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-caption text-xs text-muted-foreground">Total</span>
              <span className="font-data text-xs font-semibold text-primary">₱{order?.total?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-caption text-xs text-muted-foreground">Delivery</span>
              <span className="font-caption text-xs text-foreground">{order?.deliveryDate}</span>
            </div>
          </div>
          <div className="flex gap-3">
            <Button variant="outline" fullWidth iconName="FileText" iconPosition="left" iconSize={15} onClick={onExportPDF}>
              Export PDF
            </Button>
            <Button variant="default" fullWidth onClick={onClose}>
              Done
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}